import React from 'react';
import { getStoredCompanyPlatformDomain } from '@helpers/auth.helper';
import { useAppSelector } from '@hooks/useAppSelector';
import classNames from 'classnames';
import { useLocation } from 'react-router';
import { RootState } from 'store';
import styles from './index.module.scss';

const DefaultFooter: React.FunctionComponent = () => {
  const location = useLocation();
  const isWelcomePage = location.pathname === '/welcome';
  const companyConfigData = useAppSelector((st: RootState) => st.companyConfig);
  const hideFooterGraphic = companyConfigData?.data?.hideFooterGraphic;
  const showHapstarCopyright = !getStoredCompanyPlatformDomain();

  return (
    <footer
      className={classNames(styles.hsFooter, {
        [styles.hsFooterWelcome]: isWelcomePage,
        [styles.hsFooterNoGraphic]: hideFooterGraphic && !isWelcomePage,
      })}
    >
      <div className={styles.innerRootDesktop}>
        <div>
          <div className={styles.navRoot}>
            {showHapstarCopyright && <p>&copy; Hapstar {new Date().getFullYear()}</p>}
            <a href="/policies/terms/" target="_blank" rel="noopener noreferrer">
              Terms &amp; Conditions
            </a>
            <a href="/policies/privacy/" target="_blank" rel="noopener noreferrer">
              Privacy &amp; Cookie Policy
            </a>
          </div>
        </div>
      </div>

      <div className={styles.innerRootMobile}>
        <div className={styles.sections}>
          <div className={styles.top}>
            <a href="/policies/terms/" target="_blank" rel="noopener noreferrer">
              Terms &amp; Conditions
            </a>
            <a href="/policies/privacy/" target="_blank" rel="noopener noreferrer">
              Privacy &amp; Cookie Policy
            </a>
          </div>
          <div className={styles.bottom}>
            {showHapstarCopyright && <p>&copy; Hapstar {new Date().getFullYear()}</p>}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default DefaultFooter;
